import { render, staticRenderFns } from "./FieldsV2.vue?vue&type=template&id=f99d9aba&scoped=true"
import script from "./FieldsV2.vue?vue&type=script&lang=js"
export * from "./FieldsV2.vue?vue&type=script&lang=js"
import style0 from "./FieldsV2.vue?vue&type=style&index=0&id=f99d9aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99d9aba",
  null
  
)

export default component.exports